import { getBasePath } from '../../utils/config';
import {
  IgetTransactionsAPIBody,
  IgetDeliveryNotesColumnsAPIResponse,
  IgetDeliveryNotesItemAPIResponse,
} from './transactions.response.interface';

export const getDeliveryNotesItemsAPI = async (
  body: IgetTransactionsAPIBody,
  signal: AbortSignal,
  token: string
): Promise<IgetDeliveryNotesItemAPIResponse> => {
  const params = {
    signal: signal,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/operations/delivery_note`, params);
  const data = await response.json();
  return { response, data };
};

export const getDeliveryNotesColumnsAPI = async (
  token: string
): Promise<IgetDeliveryNotesColumnsAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${getBasePath()}/operations/delivery_note`, params);
  const data = await response.json();
  return { response, data };
};

export const getBillsItemsAPI = async (
  body: IgetTransactionsAPIBody,
  signal: AbortSignal,
  token: string
): Promise<IgetDeliveryNotesItemAPIResponse> => {
  const params = {
    signal: signal,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/operations/bills`, params);
  const data = await response.json();
  return { response, data };
};

export const getBillsColumnsAPI = async (
  token: string
): Promise<IgetDeliveryNotesColumnsAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${getBasePath()}/operations/bills`, params);
  const data = await response.json();
  return { response, data };
};

export const getOrdersItemsAPI = async (
  body: IgetTransactionsAPIBody,
  signal: AbortSignal,
  token: string
): Promise<IgetDeliveryNotesItemAPIResponse> => {
  const params = {
    signal: signal,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/operations/orders`, params);
  const data = await response.json();
  return { response, data };
};

export const getOrdersColumnsAPI = async (
  token: string
): Promise<IgetDeliveryNotesColumnsAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${getBasePath()}/operations/orders`, params);
  const data = await response.json();
  return { response, data };
};
